"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var LabelContext_1 = require("../labels/LabelContext");
var GroupContext_1 = require("../layout/GroupContext");
var classnames_1 = __importDefault(require("classnames"));
var Select_scss_1 = __importDefault(require("./Select.scss"));
var Select = function (props) {
    var _a;
    var cache = (0, react_1.useMemo)(function () {
        return props.options.reduce(function (map, o) {
            map["".concat(o.value)] = o.value;
            return map;
        }, {});
    }, [props.options]);
    var onChange = function (v) {
        if (v == "") {
            props.onChange(null);
        }
        else if (v in cache) {
            props.onChange(cache[v]);
        }
    };
    var labelCtx = (0, react_1.useContext)(LabelContext_1.LabelContext);
    var groupCtx = (0, react_1.useContext)(GroupContext_1.GroupContext);
    var state = labelCtx.state || props.state;
    return (react_1.default.createElement("select", { id: props.id || labelCtx.id, name: props.name, value: props.value ? "".concat(props.value) : "", onChange: function (e) { return onChange(e.target.value); }, className: (0, classnames_1.default)(Select_scss_1.default["au-select"], (_a = {},
            _a[Select_scss_1.default["au-select--".concat(state)]] = state,
            _a[Select_scss_1.default["au-select--block"]] = props.size == 'block',
            _a), groupCtx.className, props.className), "aria-labelledby": props.describedBy || labelCtx.describedBy, disabled: props.disabled },
        props.defaultLabel && react_1.default.createElement("option", { value: "" }, props.defaultLabel),
        props.options.map(function (o) { return (react_1.default.createElement("option", { value: "".concat(o.value), key: "".concat(o.value) }, o.label)); })));
};
exports.Select = Select;
//# sourceMappingURL=Select.js.map